import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
function getNestedColumnValues(data, key) {
  if (!data || !Array.isArray(data.plantDetails)) return [];
  return data.plantDetails.map((plant, index) => (
    <div
      key={`${key}-${index}`}
      style={{ width: "max-content", marginBottom: "0.5rem" }}
    >
      {plant[key] || "N/A"}
    </div>
  ));
}

export const HeaderConfig = [
  {
    label: "Sb No.",
    id: "sbNumber",
  },
  {
    label: "Release Date",
    id: "releaseDate",
    render: (data) => (
      <span>
        {data.releaseDate && moment(data.releaseDate).format("DD/MM/YYYY")}
      </span>
    ),
  },
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem?.name}</span>,
  },
  {
    label: "Defect",
    id: "defectCode",
    render: (data) => {
      return `${data?.defectCode?.code}-${data?.defectCode?.description}`;
    },
  },
  {
    label: "Engine Model",
    id: "engineModel",
    render: (data) => (
      <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
        {data?.engineModel?.join(", ")}
      </Box>
    ),
  },
  {
    label: "List Numbers",
    id: "listNumbers",
    render: (data) => (
      <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
        {data?.listNumbers?.join(", ")}
      </Box>
    ),
  },
  {
    label: "Plant",
    id: "plantDetails",
    columns: [
      {
        label: "Plant Name",
        id: "plantName",
        render: (data) => <>{getNestedColumnValues(data, "plantName")}</>,
      },
      {
        label: "Cut in Number",
        id: "cutInNumber",
        render: (data) => <>{getNestedColumnValues(data, "cutInNumber")}</>,
      },
      {
        label: "Cut in Date",
        id: "cutInDate",
        render: (data) => (
          <>
            {data.plantDetails?.map((plant, index) => (
              <div
                key={`cutInDate-${index}`}
                style={{ width: "max-content", marginBottom: "0.5rem" }}
              >
                {plant.cutInDate
                  ? moment(plant.cutInDate).format("DD/MM/YYYY")
                  : "N/A"}
              </div>
            ))}
          </>
        ),
      },
    ],
  },
  {
    label: "Subject",
    id: "subject",
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("DOWNLOAD", data)}>
          <Icon
            icon="tabler:download"
            width="1.5rem"
            height="1.5rem"
            style={{ color: "#095adc" }}
          />
        </IconButton>
        <IconButton onClick={() => onClick("EDIT", data)}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton>
          <DeleteIcon color="error" onClick={() => onClick("DELETE", data)} />
        </IconButton>
      </Box>
    ),
  },
];
export const getServiceInfoFormConfig = (
  oemsList = [],
  defectCodeList = [],
  handleRegexSearch
) => [
  {
    name: "sbNumber",
    type: "text",
    label: "Sb No.",
    placeholder: "Enter SI No.",
    required: true,
  },
  {
    name: "oem",
    type: "autocomplete",
    label: "OEM Org",
    options: oemsList,
    placeholder: "Select Oem",
    required: true,
    onInputChange: handleRegexSearch,
  },
  {
    name: "defectCode",
    type: "autocomplete",
    options: defectCodeList,
    label: "Defect Code",
    placeholder: "Select Defect",
    required: true,
  },
  {
    name: "releaseDate",
    type: "datePicker",
    label: "Released On",
    placeholder: "Release Date",
    required: true,
  },
];
